import { StatsEnum } from '@/enums/stats.enum';

export default {
    path: '/stats',
    component: () => import('../views/Global/StatsView.vue'),
    meta: {
        private: true,
        title: 'STATS',
    },
    children: [
        {
            path: 'account-transactions',
            name: 'account-transactions',
            component: () => import('../components/Admin/AdminStats/AdminStats.vue'),
            meta: {
                accountTypes: ['support'],
                type: StatsEnum.AccountTransactions,
            },
        },
        {
            path: 'bookkeeper-transactions',
            name: 'bookkeeper-transactions',
            component: () => import('../components/Admin/AdminStats/AdminStats.vue'),
            meta: {
                accountTypes: ['support'],
                type: StatsEnum.BookkeeperTransactions,
            },
        },
        {
            path: 'bookkeeper-leads',
            name: 'bookkeeper-leads',
            component: () => import('../components/Admin/AdminStats/AdminStats.vue'),
            meta: {
                accountTypes: ['support'],
                type: StatsEnum.BookkeeperLeads,
            },
        },
        {
            path: 'processes',
            name: 'processes',
            component: () => import('../components/Admin/AdminStats/AdminStats.vue'),
            meta: {
                accountTypes: ['support'],
                type: StatsEnum.Processes,
            },
        },
        {
            path: ':(.*)',
            redirect: { name: 'dashboard' },
        },
    ],
};
